import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import CircularProgress from "@material-ui/core/CircularProgress";
import React from "react";
import {useStyles} from "../miscellaneous/constants";

export default function Load() {

    const classes = useStyles();

    return (
        <main>
        <div className={classes.appBarSpacer}/>
        <Container maxWidth="lg" className={classes.container}
                   style={{"minHeight": "90vh", "display": "flex", "flexDirection": "column"}}>
            <Box fontWeight="fontWeightLight" fontSize="h4.fontSize" style={{
                "flexGrow": "1",
                "display": "flex",
                "flexDirection": "column",
                "justifyContent": "center",
                "alignItems": "center"
            }}>
                <CircularProgress>
                </CircularProgress>
            </Box>
        </Container>
    </main>
    )
}

